X-Content-Type-Options: nosniff

<template>
  <div class="five_box">
    <div class="five_box_sec">
      <div class="five_box_sec_tap">
        资深<span>专家阵容</span>
      </div>
      <div class="five_box_sec_span">优秀的行业专家在生殖、医疗、康养等领域我们保驾护航</div>

      <!-- 轮播阵容 -->
      <div class="five_box_lb">
        <el-carousel height="760px" arrow="never" :interval="10000">
          <el-carousel-item v-for="(item,index) in Zylistdata" :key="index" >
            <div class="five_box_list">

              <div class="five_box_list_sec" v-for="(itm,cindex) in item" :key="cindex" >
                <img class="sec_header" :src="itm.pohots" alt="">
                <div class="sec_name">{{itm.name}}</div>
                <div class="sec_titl">{{itm.title}}</div>
                <p class="sec_p" v-html="itm.abstractText"></p>
              </div>

            </div>
          </el-carousel-item>

        </el-carousel>

      </div>



    </div>



  </div>
</template>

<script>
  // 引用组件
  import Vue from "vue";
  import $ from "jquery";


  export default {
    name: ``,

    data() {
      return {
        Zylistdata: [], //专家列表

      }
    },



    created: function() {
      this.getZjList()

    },



    methods: {

      // 专家
      getZjList() {
        $.ajax({
          url: this.$baseUrl + "queryAllData/100001",
          type: "get",
          timeout: 9999999999, 
          contentType: false, //multipart/form-data
          cache: true, //是否缓存，推荐使用。用于性能优化，减少http请求
          dataType: "json",
          success: (res, statusTest, xhr) => {
            console.log(res)
            this.getMapping(res.data)

          }

        })

      },

      // 专家分组
      getMapping(list) {
        let len = list.length
        let newList = []
        if (len) {
          var chunk = 6
          for (var i = 0, j = len; i < j; i += chunk) {
            this.Zylistdata.push(list.slice(i, i + chunk))
          }
        }
      },
    }
  }
</script>

<style >

 .el-carousel__indicator--horizontal .el-carousel__button {
    width: 40px;
    height: 4px;
    background-color: #d8d8d8;
    opacity: 0.5;
    border-radius: 20px;
  }

 .el-carousel__indicator--horizontal.is-active .el-carousel__button {
    width: 40px;
    height: 4px;
    background: #BF292C;
    opacity: 1;
    border-radius: 20px;
  }

  /* 第五页 */
  .five_box {
    width: 100%;
    height: auto;
  }

  .five_box_sec {
    width: 90%;
    height: auto;
    margin: 0 auto;
    margin-top: 12%;
  }

  .five_box_sec_tap {
    width: 100%;
    font-size: 36px;
    font-weight: normal;
    color: #BF292C;
    padding-bottom: 16px;
  }

  .five_box_sec_tap span {
    font-size: 36px;
    color: #000;
  }

  .five_box_sec_span {
    font-weight: 400;
    color: #4D4D4D;
    line-height: 30px;
    margin-bottom: 2%;
  }

  .five_box_lb {
    width: 100%;
    height: 720rpx;
  }

  .five_box_list {
    width: 100%;
    height: auto;
    overflow: hidden;
  }

  .five_box_list_sec {
    text-align: center;
    height: 360px;
    padding: 10px 0;
    transform: all 0.5s linear;
    opacity: 0.7;
    -moz-opacity: 0.7;
    -webkit-opacity: 0.7;
    filter: alpha(opacity=70);
    transition: all 0.5s linear;
    -webkit-transition: all 0.5s linear;
    float: left;
    width: 33%;
    margin: 0 auto;
  }

  .five_box_list_sec:hover {
    opacity: 1;
    -moz-opacity: 1;
    -webkit-opacity: 1;
    filter: alpha(opacity=100);
    transform: scale(1.1);
    -webkit-transform: scale(1.1);
    -moz-transform: scale(1.1);
    transform: all 0.5s linear;
    cursor: pointer;
    background: #FFF;
    box-shadow: 0px 12px 32px 0px rgba(11, 20, 57, 0.0600), 0px 4px 12px 0px rgba(0, 0, 0, 0.0300);
  }


  .sec_header {
    width: 170px;
    height: 170px;
    border-radius: 85px;
    overflow: hidden;
    margin: 20px auto;
  }

  .sec_name {
    font-size: 20px;
    line-height: 28px;
    color: #061D38;
    font-weight: bold;
  }

  .sec_titl {
    line-height: 25px;
    font-size: 14px;
    color: #061D38;
    font-weight: bold;
  }

  .sec_p {
    width: 50%;
    display: block;
    margin: 0 auto;
    line-height: 25px;
    font-size: 14px;
  }

  /* 第六页 */
  .six_box {
    width: 100%;
    height: auto;
  }

  .six_box_sec {
    width: 90%;
    height: auto;
    margin: 0 auto;
    padding-top: 5%;
    display: flex;
    flex-direction: row;
  }

  .six_box_sec_left {
    width: 66%;
    height: auto;
  }

  .six_top {
    width: 100%;
    height: auto;
    font-size: 36px;
    font-weight: normal;
    color: #BF292C;
    margin-bottom: 20px;
    text-align: right;
  }

  .six_top span {
    font-size: 36px;
    color: #000;
  }

  .six_top_p {
    width: 100%;
    display: block;
    font-size: 14px;
    font-weight: 400;
    color: #4D4D4D;
    line-height: 30px;
    text-align: right
  }

  .six_list_box {
    width: 100%;
    height: auto;
    padding-right: 8%;
    text-align: right;
    margin-top: 75px;
    display: flex;
    align-items: center;
    justify-content: right;
    padding-bottom: 20px;
  }

  .six_list_box div {
    width: 80%;
    color: #797979;
    font-size: 18px;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    cursor: pointer
  }

  .six_list_box div:hover {
    color: #BF292C
  }


  .six_list_box span {
    width: 10px;
    height: 10px;
    background: #999;
    display: inline-block;
    margin-left: 5px;
  }


  .six_box_sec_right {
    width: 30%;
    height: auto;
    margin-top: 90px;
  }




  .four_btn {
    width: 123px;
    height: 62px;
  }

  .two_bottom {
    display: flex;
    flex-direction: row;
    position: absolute;
    z-index: 10000;
    bottom: 15%;
    right: 0%;
  }
</style>



// WEBPACK FOOTER //
// src/components/indexFive.vue